export default class SpecialityTranslation {

    id: number;
    name: string;
    plural: string;
    locale: string;
    speciality_id: number;
}
